module.exports = __webpack_public_path__ + "static/img/ent-54.1429a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-54.jpg
// module id = +CJH
// module chunks = 51